import { useEffect, useState } from 'react'
import { useIntersectionObserver } from 'usehooks-ts'

import StickyHeader from '../ui/StickyHeader'


export default function useStickyHeader () {
  const [ showStickyHeader, setShowStickyHeader ] = useState<boolean>(false)
  
  const { ref: observerRef, isIntersecting } = useIntersectionObserver({
    threshold: 0,
    rootMargin: '0px',
  })

  useEffect(() => {
    if (isIntersecting !== undefined) {
      setShowStickyHeader(!isIntersecting)
    }
  }, [ isIntersecting ])

  return {
    observerRef,
    showStickyHeader,
    StickyHeader: () => <StickyHeader isVisible={showStickyHeader} />
  }
}